import './index.scss'

import { Outlet } from 'react-router-dom'

import PageTabs from '@components/PageTabs'

export default function VolunteeringPage() {
  return (
    <div className='volunteering-page'>
      <PageTabs
        title='Volunteering'
        tabs={[
          { label: 'Teams', path: '/volunteering' },
          { label: 'Training Modules', path: '/volunteering/training' }
        ]} />

      <Outlet />
    </div>
  )
}
